import {
  OPENING_HOURS_KEY,
  TEXT_KNOWLEDGE_ITEM_KEY,
} from "../../../../services-logic/knowledge-base/knowledge-base-logic";
import KnowledgeBaseOpeningHourItem from "./knowledge-base-items/KnowledgeBaseOpeningHourItem";
import KnowledgeBaseTextItem from "./knowledge-base-items/KnowledgeBaseTextItem";

const ITEM_COMPONENTS = {
  [OPENING_HOURS_KEY]: KnowledgeBaseOpeningHourItem,
  [TEXT_KNOWLEDGE_ITEM_KEY]: KnowledgeBaseTextItem,
};

const KnowledgeBaseAccordionBody = ({ item, index, onUpdateKnowledgeItem }) => {
  const Component = ITEM_COMPONENTS[item.type];

  if (!Component) {
    console.error(`Unknown component type: ${item.type}`);
    return null;
  }

  return <Component item={item} index={index} onUpdateKnowledgeItem={onUpdateKnowledgeItem} />;
};

export default KnowledgeBaseAccordionBody;
